<template>
    <outboxCon>
        <div class="teach-quality">
            <app-title :main='main' :sub='sub'></app-title>
            <img class="icon-quality" :style="{ width: `${imgW}px`, height: `${imgH}px`}" :src="imgUrl">
        </div>
    </outboxCon>
</template>
<script>
import methosScroll from './hashScroll/methodScroll'
export default {
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    imgW: {
      type: Number,
      default: 890
    },
    imgH: {
      type: Number,
      default: 556
    },
    bg: {
      type: String,
      default: ''
    },
    main: {
      type: String,
      default: ''
    },
    sub: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  components: { methosScroll }
}
</script>
<style lang="scss" scoped>
    .teach-quality{
        width: $main-width;
        margin: 0 auto;
        padding: 50px 0px 60px 0px;
        position: relative;
        .icon-quality{
            display: block;
            margin: 44px auto 0px;
        }
    }
</style>
